<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { ref } from 'vue';
import ArrowDown from '../General/ArrowDown.vue';
import Button from '../General/Button.vue';

interface Props {
    point: number
}
const { point } = defineProps<Props>()
const emit = defineEmits<{ update: [value: number] }>()
const updatePoint = ref<number>(point)
const pointNumberRangeNegative = [-3, -1]
const pointNumberRangePositive = [1, 3]

function handlePointNumberClick(pointNumber: number) {
    updatePoint.value = Math.max(updatePoint.value + pointNumber, 0)
}

function handleSetPointConfirm() {
    if (point === updatePoint.value) return;
    emit('update', updatePoint.value)
}

const { t } = useI18n()
</script>

<template>
    <div class="mt-7 mb-1 text-center">
        {{ t(TEXT.current_point) }}
    </div>
    <div class="flex flex-wrap gap-3 sm:gap-4 items-center justify-center">
        <Button v-for="pointNumber in pointNumberRangeNegative" color="danger" class="size-12"
            @click="handlePointNumberClick(pointNumber)">
            {{ pointNumber }}
        </Button>
        <div class="font-bold text-3xl mx-2 sm:mx-8">
            {{ point }}
        </div>
        <Button v-for="pointNumber in pointNumberRangePositive" color="success" class="size-12"
            @click="handlePointNumberClick(pointNumber)">
            +{{ pointNumber }}
        </Button>
    </div>
    <ArrowDown class="mx-auto my-4" :class="{ 'invisible': point === updatePoint }"
        :color="point === updatePoint ? 'gray' : point > updatePoint ? 'danger' : 'success'" />
    <div class="font-bold text-3xl text-center mb-5" :class="{ 'invisible': point === updatePoint }">
        {{ updatePoint }}
    </div>
    <Button :color="point === updatePoint ? 'gray' : 'warning'" class="mx-auto mb-3" :disabled="point === updatePoint"
        @click="handleSetPointConfirm">
        {{ t(TEXT.confirm) }}
    </Button>
</template>